import { extractProperty } from "./extractProperty"

type BasicProperty = {
  __typename: "BasicProperty"
  property: BasicPropertyValue | BasicContentPicker
}

type BasicPropertyValue = {
  __typename: "BasicPropertyValue"
  menuName: string
}

type BasicContentPicker = {
  __typename: "BasicContentPicker"
  menuTarget: BasicContentPickerItem[]
}

type BasicContentPickerItem = {
  __typename: "BasicContentPickerItem"
  id: number
  absoluteUrl: string
  key: string
  name: string
  url: string
  urlSegment: string
}

type InputType = {
  __typename: "BasicContent"
  children: any[]
  properties: BasicProperty[]
}

export function extractMenuProperties(item: InputType) {
  let button = extractProperty(item, "button")
  let title: string = extractProperty(item, "title")
  let color: string = extractProperty(item, "color")
  let subtitle: string = extractProperty(item, "subtitle")
  let desktopImage: string = extractProperty(item, "desktopImage")
  let image: string = extractProperty(item, "image")
  let url = extractProperty(item, "link")[0]
  let logo: string = extractProperty(item, "logo")
  let icon: string = extractProperty(item, "icon")
  let text: string = extractProperty(item, "text")
  let bulets: string = extractProperty(item, "bulets")
  let subText: string = extractProperty(item, "subText")
  let siteLogo: string = extractProperty(item, "siteLogo")
  let clickToCall = extractProperty(item, "clickToCall")
  let phoneNumber = extractProperty(item, "phoneNumber")
  let footerMenu = extractProperty(item, "footerMenu")
  let linkName = extractProperty(item, "linkName")
  let linkUrl = extractProperty(item, "linkUrl")
  let socialLinks = extractProperty(item, "socialLinks")
  let primaryColor = extractProperty(item, "primaryColor")
  let absoluteUrl = extractProperty(item, "absoluteUrl")
  return {
    button,
    title,
    color,
    subtitle,
    desktopImage,
    url,
    logo,
    icon,
    text,
    bulets,
    subText,
    siteLogo,
    clickToCall,
    phoneNumber,
    footerMenu,
    linkName,
    linkUrl,
    socialLinks,
    image,
    primaryColor,
    absoluteUrl,
  }
}

export function extractMenuPropertiesSideBar(item: InputType) {
  let url: string = ""
  let title: string = ""
  let name: string = ""
  if (item?.properties?.[0]?.property?.__typename === "BasicPropertyValue") {
    title = item.properties[0].property.menuName
  }

  if (item?.children[0]?.properties?.[1].property?.menuTarget?.[0]?.name) {
    name = item?.children[0]?.properties?.[1].property.menuTarget?.[0].name
  }
  if (
    item?.properties?.[1]?.property?.__typename === "BasicPropertyValue" &&
    item?.properties?.[1]?.property?.menuName
  ) {
    url = item.properties[1].property.menuName || ""
    return { url, title, name }
  }
  if (item?.properties?.[1]?.property?.__typename === "BasicContentPicker") {
    url =
      item.properties[1].property.menuTarget[0]?.url?.replace("/pazcorp", "") ||
      ""
  }

  if (item?.properties?.[0]?.property?.__typename === "BasicPropertyValue") {
    title = item.properties[0].property.menuName
  }

  return { url, title, name }
}
